"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorators = void 0;

var _decorators = require("../decorators");

var decorators = [_decorators.withGrid, _decorators.withBackground];
exports.decorators = decorators;